import React from 'react';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';
import {
  SelectFolderField,
  UploadDocumentField
} from 'modules/components/layer04';
import * as ds from './dataService';

import { SaveDocumentInput } from 'generated/graphql';

export type SaveDocumentFormProps = {
  id: string;
  projectId: string;
  folderId: string;
  handleClose: () => void;
};

export const FC = (props: SaveDocumentFormProps) => {
  const [
    fnSaveForm,
    { loading }
  ] = ds.useSaveDocument();
  const form = ds.useFormState(props.id, props.projectId, props.folderId);
  const handleSubmit = async () => {
    const input: SaveDocumentInput = {
      ...form.formState,
      folderId: form.formState.folderId === '' ? null : form.formState.folderId
    };
    if (input.apiFileId === '') {
      return;
    }
    await fnSaveForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit();
        props.handleClose();
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >



      <StyledTextField.FC
        placeholder='Enter new name to overide default'
        {...form.genFieldProps('title')}
      />
      <SelectFolderField.FC
        form={form}
        fieldName='folderId'
      />

      <UploadDocumentField.FC
        form={form}
        fieldName='apiFileId'
      />

    </FormBaseLayout.FC>

  );
};
